import request from '@/utils/request'; // 获取报修列表

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/garageCarUser/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/garageCarUser/insert',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/garageCarUser/get',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/garageCarUser/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/garageCarUser/update',
    method: 'post',
    data: data
  });
}
export function importExcel(data) {
  return request({
    url: '/pmsservice/api/garageCarUser/exportGarageCarUser',
    method: 'post',
    data: data
  });
}
export function importExcelNoUser(data) {
  return request({
    url: '/pmsservice/api/garageCarUser/exportGarageCarUserNoUser',
    method: 'post',
    data: data
  });
} // 通过业主获取停车场和车位层级关系

export function fetchGarageAndParkingLot(data) {
  return request({
    url: '/pmsservice/api/garageCarUser/findGarageAndParkingLot',
    method: 'post',
    data: data
  });
}